import { DrawerProps } from 'antd/lib/drawer';
import * as React from 'react';


export interface IContextState {
    open: boolean
    title: React.ReactNode
    content: React.ReactNode
    DrawerProps?: DrawerProps
    onClose(): any
}

export const initialState: IContextState = {
    open: false,
    title: undefined,
    content: undefined,
    onClose: () => {
        throw new Error('Drawer Provider Context `close()` function is not implemented');
    },
};

interface IReducerAction extends IContextState {
    actionType: 'OPEN' | 'CHANGE' | 'CLOSE' | 'RESET'
}

const reducer = (state: IContextState = initialState, { actionType, ...options }: IReducerAction) => {
    switch (actionType) {
        case 'OPEN':
            return { ...state, ...options, open: true };
        case 'CHANGE':
            return { ...state, ...options };
        case 'CLOSE':
            return { ...state, ...options, open: false };
        case 'RESET':
            return initialState;
    }
};

interface IDrawerProviderActionOptions {
    title?: React.ReactNode
    content?: React.ReactNode
    DrawerProps?: DrawerProps
    onClose?(): any
}

export const drawerProviderActions = {
    openDrawer: (options?: IDrawerProviderActionOptions) => ({ ...options, actionType: 'OPEN' } as IReducerAction),
    closeDrawer: (options?: IDrawerProviderActionOptions) => ({ ...options, actionType: 'CLOSE' } as IReducerAction),
    changeDrawer: (options?: IDrawerProviderActionOptions) => ({ ...options, actionType: 'CHANGE' } as IReducerAction),
    resetDrawer: (options?: IDrawerProviderActionOptions) => ({ ...options, actionType: 'RESET' } as IReducerAction),
};

interface IContextProviderValue {
    state: IContextState
    dispatch: React.Dispatch<IReducerAction>
}

const Context = React.createContext({} as IContextProviderValue);

interface IProviderProps {
    children: React.ReactNode
}

export const Provider = ({ children }: IProviderProps) => {
    const [state, dispatch] = React.useReducer(reducer, initialState);
    return (
        <Context.Provider value={{ state, dispatch }}>
            {children}
        </Context.Provider>
    );
};

export default Context;
